import SignIn from 'views/sign-in'

export default SignIn
